import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.4911 6.25506C13.6648 6.08965 13.896 5.99821 14.1359 6.00003C14.3758 6.00184 14.6056 6.09677 14.7768 6.26478C14.948 6.4328 15.0473 6.66075 15.0536 6.90055C15.0599 7.14034 14.9729 7.37323 14.8108 7.55005L9.88979 13.7044C9.80517 13.7955 9.70305 13.8686 9.58951 13.9194C9.47598 13.9702 9.35338 13.9975 9.22904 13.9998C9.10469 14.0021 8.98116 13.9793 8.86583 13.9328C8.75049 13.8863 8.64573 13.817 8.5578 13.729L5.29441 10.4656C5.20353 10.381 5.13063 10.2788 5.08008 10.1654C5.02952 10.0519 5.00234 9.92942 5.00014 9.80522C4.99795 9.68102 5.0208 9.55765 5.06732 9.44248C5.11384 9.3273 5.18309 9.22267 5.27093 9.13483C5.35876 9.047 5.46339 8.97775 5.57857 8.93123C5.69375 8.88471 5.81712 8.86186 5.94132 8.86405C6.06552 8.86624 6.188 8.89343 6.30147 8.94398C6.41493 8.99454 6.51705 9.06743 6.60173 9.15831L9.18433 11.7397L13.4677 6.28219C13.4754 6.27269 13.4836 6.26364 13.4923 6.25506H13.4911Z",
		fill: "#007CBB"
	})
});
export default SvgCheck;
